import React from 'react';
import { Error500 } from '../../asset';
import PrimaryButton from '../../component/button/PrimaryButton';
import { t } from 'i18next';

const ErrorPage500 = () => {
  return (
    <div className='flex flex-col justify-center items-center'>
      <img src={Error500} alt='img-error-500' />
      <p className='font-sans font-bold text-4xl mt-[24px]'> Internal Server Error </p>
      <p className='font-sans font-bold text-2xl mt-[24px]'> 
        Please try again later,
      </p>
      <p className='font-sans font-bold text-2xl'>
        or feel free to contact us if the problem persist.
      </p>
      <PrimaryButton 
          styles='mt-[24px]'
          // action={() => setStartOpen(true)} 
          text={t("Back To Home")} 
        />
    </div>
  );
};

export default ErrorPage500;